import './polyfill';
import {init} from '@livechat/customer-sdk';
import * as DOMElements from './DOMElements';
import * as DOMOperations from './DOMOperations';
import * as Hawk from './hawk';
import {start_widget} from './trimtab';
import {CallToBack} from "./callback";

const isDebug = window.location.hash === "#debug" || window.location.hash === "debug";

const $ = window.jQuery || window.$;

function Tooltip(container, options) {
    var that = this;

    this.container = container;

    this.defaultOptions = {
        tooltipContainerClass: 'tooltip-item__tooltip-container',
        buttonClass: 'tooltip-item__button',
        closeClass: 'tooltip-item__close'
    }

    this.options = Hawk.mergeObjects(this.defaultOptions, options);

    this.button;
    this.tooltipContainer;
    this.close;

    this.run = function () {
        this.button = this.container.find('.' + this.options.buttonClass);
        this.close = this.container.find('.' + this.options.closeClass);
        this.tooltipContainer = this.container.find('.' + this.options.tooltipContainerClass);

        this.button.click(function (e) {
            e.preventDefault();

            that.tooltipContainer.fadeIn();
        });

        this.close.click(function (e) {
            e.preventDefault();

            that.tooltipContainer.fadeOut();
        });
    }
}

const call_to_back = new CallToBack();
if (isDebug) {
    window.call_to_back = call_to_back;
    window.DOMElements = DOMElements;
}

var offlineConditionsTooltip = new Tooltip($('#offline-conditions-tooltip'));
offlineConditionsTooltip.run();

var conditionsTooltip = new Tooltip($('#conditions-tooltip'));
conditionsTooltip.run();
var conditionsTooltip2 = new Tooltip($('#callback-form-conditions-tooltip'));
conditionsTooltip2.run();

DOMElements.widgetClose.innerHTML = DOMElements.parpLogoLoader;

const loader = document.getElementById('lc-loader')
loader.innerHTML = DOMElements.logoLoader
loader.style.display = 'none';

const historyStates = {
    DONE: 'DONE',
    INACTIVE: 'INACTIVE',
    LOADING: 'LOADING',
}

const noop = () => {
}

const client_id = DOMElements.lcWindow.dataset.client;
const license_id = parseInt(DOMElements.lcWindow.dataset.license);
if (isDebug) console.log("Starting LC SDK,", {client_id, license_id});
const sdk = init({licenseId: license_id, clientId: client_id});
window.sdk = sdk

const state = {
    chat: null,
    active: false,
    activating: false,
    users: {},
    pendingMessages: [],
    customerId: null,
    historyStatus: historyStates.INACTIVE,
    history: null,
}
window.xxx_state = state;

const isAgent = user => user.id !== state.customerId


//DOMOperations.showStartChatButton();

const loadChat = function (chatsSummary, totalChats, agentsOnline) {
    if (isDebug) console.log("loading chat")

    if (agentsOnline) {
        DOMOperations.enableInput()
        DOMOperations.enableSendButton()
    }

    if (isDebug) console.log(chatsSummary);
    if (isDebug) console.log(totalChats);

    if (agentsOnline) {
        DOMOperations.showFooter()
        DOMOperations.showPresurvey()
        DOMOperations.showStartChatButton()
    } else {
        DOMOperations.showOfflineSection();
    }

    if (typeof chatsSummary != 'undefined' && typeof chatsSummary[0] != 'undefined') {
        state.chat = chatsSummary[0].id
        state.active = chatsSummary[0].active
    }
}

sdk.on("chat_thread_properties_updated", payload => {
    if (isDebug) console.log({
        "msg": "chat_thread_properties_updated",
        payload: payload,
    })
    /**    console.log("chat_thread_properties_updated");
     console.log(payload.chat);
     console.log(payload.thread);
     console.log(payload.properties);**/
});

sdk.on("chat_properties_updated", payload => {
    if (isDebug) console.log({
        "msg": "chat_properties_updated",
        payload: payload,
    })
    /**console.log("chat_properties_updated");
     console.log(payload.chat);
     console.log(payload.properties);**/
});

const on_submit_offline_form = (e) => {
    e.preventDefault();

    if (!DOMElements.offlineFormConditions.checked) {
        if (isDebug) console.log("Conditions not checked");
        DOMElements.offlineFormConditionsTooltip.querySelector('.error').style.display = 'block';
        return;
    } else {
        if (isDebug) console.log("Conditions checked");
        DOMElements.offlineFormConditionsTooltip.querySelector('.error').style.display = 'none';
    }

    const fields = DOMOperations.formToData(DOMElements.offlineForm);
    if (isDebug) console.log("on_submit_offline_form", {fields});
    loader.style.display = 'block';
    DOMElements.offlineSection.style.display = 'none';
    sdk
        .sendTicketForm({
            filledForm: {
                type: 'filled_form',
                formId: 'ticket',
                fields: fields,
            },
        })
        .then(response => {
            if (isDebug) console.log(`Created a ticket with id: ${response.id}`)
            loader.style.display = 'none';
            DOMElements.offlineSection.style.display = 'block';
            DOMElements.offlineSectionOffline.style.display = 'none';
            DOMElements.offlineSectionOccupied.style.display = 'none';
            DOMElements.offlineForm.style.display = 'none';
            DOMElements.offlineMessageSent.style.display = 'block';
        })
        .catch(error => {
            if (isDebug) console.log('Form submit error', error)
            loader.style.display = 'none';
            DOMElements.offlineSection.style.display = 'block';
            DOMElements.offlineFormInfo.classList.add('error');
            DOMElements.offlineFormInfo.innerText = 'Nie udało się wysłać formularza. Prosimy spróbować ponownie później.';
        })
};

let form_loaded = false;
sdk.on('connected', (payload) => {
    // console.log("connected");
    // console.log(payload);

    if (state.chat) {
        return
    }

    // region Get offline form
    if (!form_loaded) {
        sdk
            .getForm({
                groupId: 0,
                type: 'ticket',
            })
            .then(response => {
                if (!form_loaded) {
                    form_loaded = true;
                    if (response.enabled) {
                        console.log('form', response, response.form);
                        DOMOperations.formDataToForm(response.form.fields, on_submit_offline_form);
                    }
                }
            })
            .catch(error => {
                if (isDebug) console.log({
                    msg: 'Get offline form error',
                    error: error,
                });
            });
    }
    // endregion Get offline form

    var chatsSummary;
    var totalChats;

    var tmp = sdk.listChats();

    tmp.then((obj) => {
        //console.log(obj);

        chatsSummary = obj.chatsSummary;
        totalChats = obj.totalChats;

        try {
            sdk
                .getPredictedAgent()
                .then(agent => {
                    loadChat(chatsSummary, totalChats, true);

                    // console.log("są agenci");
                    // console.log(chatsSummary);
                    // console.log("loadchat", "sągagenci?");
                })
                .catch(error => {
                    loadChat(chatsSummary, totalChats, false);


                    // console.log("nie ma agentow");
                    // console.log(error);
                    // console.log(chatsSummary);
                    // console.log("loadchat", "pierwszycatch");

                    //console.log('promise catch ' + totalChats);

                    return;
                });
        } catch (e) {
            loadChat(chatsSummary, totalChats, false);

            // console.log("loadchat", "catch");
            // console.log(chatsSummary);

            return;
        }
    })
        .catch((error) => {
            //console.log(error);


            chatsSummary = {};
            totalChats = 0;

            loadChat(chatsSummary, totalChats, false);
        });

    //console.log(chatsSummary);
// console.log(sdk.listChats());

// 	console.log(chatsSummary);
// 	console.log(totalChats);


    //DOMOperations.showOfflineAgentsInfo();
    //loadChat(chatsSummary, totalChats, true);


})

// var date = new Date();

// console.log("Czy po godzinach pracy? (expected false)");
// console.log(date)
// console.log(DOMOperations.isAfterWorkHours(date));

// var otherDate = new Date();
// otherDate.setDate(20);

// console.log("Czy po godzinach pracy? (expected true)");
// console.log(otherDate);
// console.log(DOMOperations.isAfterWorkHours(otherDate));

// var anotherDate = new Date();
// anotherDate.setHours(18);

// console.log("Czy po godzinach pracy? (expected true)");
// console.log(anotherDate);
// console.log(DOMOperations.isAfterWorkHours(anotherDate));

sdk.on('connection_restored', noop)
sdk.on('thread_summary', function (e) {
    if (isDebug) console.log({
        msg: "thread_summary",
        e: e,
    })
})
sdk.on('user_is_typing', noop)
sdk.on('user_stopped_typing', noop)
sdk.on('user_joined_chat', noop)
sdk.on('user_left_chat', function (e) {
    if (isDebug) console.log({
        msg: "user_left_chat",
        e: e,
    })
    //console.log(e);
    //console.log("user left the chat");

    var finished = '<div id="chat-finished-section" class="chat-finished-section">';
    finished += '<div class="livechat__chat-info">';
    finished += 'Czat zakończył się';
    finished += ' </div>';

    finished += '  <div class="livechat__chat-button">';
    finished += '<a class="simple-button start-again-button" tabindex="0" href="again">Rozpocznij ponownie</a>';
    finished += '</div></div>';

    var finishedMessage = $(finished);

    DOMOperations.appendMessage(finishedMessage.get(0));

    DOMOperations.hideFooter();

});

/**var finished = '<div id="chat-finished-section" class="chat-finished-section">';
 finished  += '<div class="livechat__chat-info">';
 finished  += 'Czat zakończył się';
 finished  += ' </div>';

 finished  += '  <div class="livechat__chat-button">';
 finished  += '<button class="simple-button start-again-button">Rozpocznij ponownie</button>';
 finished  += '</div></div>';

 var finishedMessage = $(finished);

 DOMOperations.appendMessage(finishedMessage.get(0));**/

$('#chat').on('click', '.start-again-button', function (e) {
    e.preventDefault();

    DOMElements.presurveyName.value = '';
    DOMElements.presurveyEmail.value = '';
    DOMElements.presurveyPhone.value = '';
    DOMElements.presurveyQuestion.value = '';
    DOMElements.presurveyConditions.checked = false;

    DOMOperations.showStartChatButton();

    DOMOperations.showPresurvey();

    DOMOperations.showFooter();

    var chat = $(DOMOperations.getMessageList());
    chat.empty();
    chat.append("<div></div>");
});

sdk.on('customer_id', id => {
    state.customerId = id
})

const onConnectionLost = () => {
    //console.log('connection lost');
    DOMOperations.disableInput('Disconnected')
    DOMOperations.disableSendButton()
}

sdk.on('connection_lost', () => {
    onConnectionLost()
})

sdk.on('diconnected', reason => {
    //console.log("disconnected", reason);

    onConnectionLost()
});


sdk.on('user_data', user => {
    state.users[user.id] = user
});

const putMessage = (event) => {
    const author = state.users[event.authorId];

    DOMOperations.appendMessage(
        DOMOperations.createMessage(event.id, event.text, isAgent(author) ? 'agent' : 'customer', author.avatar),
    );
}

sdk.on('incoming_event', ({chat, event}) => {
    if (isDebug) console.log({
        msg: "incoming_event",
        chat: chat,
        event: event,
    });

    if (!state.chat || event.type !== 'message') {
        return
    }

    if (!DOMOperations.isFooterShown()) {
        DOMOperations.showFooter();
        DOMOperations.showChat();
    }

    const author = state.users[event.authorId];

    DOMOperations.appendMessage(
        DOMOperations.createMessage(event.id, event.text, isAgent(author) ? 'agent' : 'customer', author.avatar),
    )
})

const sendMessage = (chat, id, text) => {
    const message = {text: text, type: 'message'}

    const param = {
        chatId: chat,
        chat_id: chat,
        event: message
    };

    if (isDebug) console.log("SEND MESSAGE: " + text + "\t" + JSON.stringify(param));

    try {
        sdk.sendEvent(param).then(
            confirmedMessage => {
                DOMOperations.confirmMessageAsSent(id)
            },
            () => {
                DOMOperations.markAsFailedMessage(id)
            },
        );
    } catch (e) {
        if (isDebug) console.log("blad wysylabia wiadomosci: " + text + "\t" + JSON.stringify(e));
    }
}

const _chatStarted = function (chat, state, callback, resumed = false) {
    if (isDebug) console.log("_chatStarted", {chat, state});

    if (chat && chat.thread && chat.thread.events) {
        for (let i in chat.thread.events) {
            if (isDebug) console.log(JSON.stringify(chat.thread.events[i]));

            putMessage(chat.thread.events[i]);
        }
    }

    const chatId = (chat && chat.id) ? chat.id : state.chat;
    if (isDebug) console.log(`chatId: ${chatId}`);

    state.chat = chatId;
    state.active = true;
    state.activating = false;
    state.historyStatus = historyStates.DONE;
    state.pendingMessages.forEach(({messageId: customId, text: message}) => {
        sendMessage(chatId, customId, message);
    });
    state.pendingMessages = [];

    let wholeChatHistoryLoaded = false;

    if (isDebug) console.log(`getting history for ${chatId}`);
    const history = sdk.getChatHistory({chatId});

    history.next().then(result => {
        if (result.done) {
            wholeChatHistoryLoaded = true;
        }

        // console.log(result);

        const events = result.value;

        // console.log(events);

        for (var i = 0; i < events.length; i++) {
            if (isDebug) console.log(events[i]);
        }
    });

    if (resumed) {
        try {
            loadInitialHistory().then(() => {
                if (typeof callback == 'function') {
                    callback();
                }
            });
        } catch (e) {
            if (isDebug) console.log("ERROR loading history: " + JSON.stringify(e));
        }
    } else if (typeof callback == 'function') {
        callback();
    }
};
const startChat = (callback) => {
    state.activating = true

    try {
        if (state.chat) {
            if (isDebug) console.log("niby jakis aktywny: ", {state});

            sdk.resumeChat({chat: {id: state.chat}})
                .then((id) => {
                    DOMOperations.showChat();
                    _chatStarted(id, state, callback);
                })
                .catch((error) => {
                    if (error.code && error.code === "CHAT_ALREADY_ACTIVE") {
                        DOMOperations.showChat();
                        _chatStarted(null, state, callback, true);
                        return;
                    }
                    state.activating = false
                    state.pendingMessages.forEach(({messageId: id}) => DOMOperations.markAsFailedMessage(id))
                    state.pendingMessages = [];

                    if (isDebug) console.log("Error aktywacji: ", {error, state});
                });
        } else {
            if (isDebug) console.log("nowy czat");

            sdk.startChat().then(({chat}) => {
                DOMOperations.showChat();

                if (isDebug) console.log("NOWY CZAT", {chat});

                _chatStarted(chat, state, callback);
            })
                .catch((error) => {
                    state.activating = false
                    state.pendingMessages.forEach(({messageId: id}) => DOMOperations.markAsFailedMessage(id))
                    state.pendingMessages = [];

                    if (isDebug) console.log("Error startu: ", {error, state});
                });
        }
    } catch (error) {
        if (isDebug) console.log("Outer error: ", {error});
    }
}

const handleMessage = () => {
    const text = DOMElements.input.value
    DOMElements.input.value = ''

    deliverMessage(text);
}

const prepareText = function (text) {
    text = text.replace('"', "&rdquo;");
    text = text.replace("'", "&apos;");
    text = text.replace("<", "&lt;");
    text = text.replace(">", "&gt;");

    return text;
}

const deliverMessage = function (text) {
    if (!text) {
        return
    }

    text = prepareText(text);

    const messageId = `${Math.random() * 1000}`

    if (state.active) {
        sendMessage(state.chat, messageId, text)
    } else {
        state.pendingMessages.push({messageId, text});

        if (!state.active) {
            //startChat()
        }
    }

    DOMOperations.appendMessage(DOMOperations.createMessage(messageId, text, 'customer'))
    DOMOperations.scrollToBottom()
}

let firstAttemptStartingChat = true;

const tryToStartChat = function (e) {
    e.preventDefault();

    // validation
    var name = DOMElements.presurveyName.value.trim();
    var email = DOMElements.presurveyEmail.value.trim();
    var phone = DOMElements.presurveyPhone.value.trim();
    var question = DOMElements.presurveyQuestion.value.trim();
    var conditions = DOMElements.presurveyConditions.checked;

    var errorOccurred = false;
    var errors = {
        fields: false,
        conditions: false
    };

    if (name.length == 0) {
        errorOccurred = true;
        errors.fields = true;

        DOMElements.presurveyNameContainer.classList.add("error");
    } else {
        DOMElements.presurveyNameContainer.classList.remove("error");
    }

    if (email.length == 0) {
        errorOccurred = true;
        errors.fields = true;

        DOMElements.presurveyEmailContainer.classList.add("error");
    } else {
        DOMElements.presurveyEmailContainer.classList.remove("error");
    }

    if (question.length == 0) {
        errorOccurred = true;
        errors.fields = true;

        DOMElements.presurveyQuestionContainer.classList.add("error");
    } else {
        DOMElements.presurveyQuestionContainer.classList.remove("error");
    }

    if (!conditions) {
        errorOccurred = true;
        errors.conditions = true;
    }

    if (!errorOccurred) {
        DOMElements.presurveyInfoContainer.style.display = 'none';

        const customerProperties = {
            name: name,
            email: email/**,
             fields: {
		    custom_property: "BasketValue=10usd",
		    any_key_is_ok: "sample custom field"
		  }**/
        };

        if (phone.length > 0) {
            customerProperties.sessionFields = {
                phone: phone
            };
        }

        sdk.updateCustomer(customerProperties);

        DOMOperations.hidePresurvey();

        startChat(function () {
            //console.log("Sending messageeee");
            deliverMessage(question);
        });
    } else {
        if (firstAttemptStartingChat) {
            $(DOMElements.presurveyInfoContainer).hide();
        } else {
            $(DOMElements.presurveyInfoContainer).animate({opacity: 0});
        }

        DOMElements.presurveyInfo.innerHTML = "";

        if (errors.fields) {
            DOMElements.presurveyInfo.innerHTML = "<p class=\"error\">Proszę poprawnie wypełnić wszytkie pola.</p>";
        }

        if (errors.conditions) {
            DOMElements.presurveyInfo.innerHTML += "<p class=\"error\">Proszę zaakceptować warunki.</p>";

            DOMElements.presurveyConditionsContainer.classList.add("error");
        } else {
            DOMElements.presurveyConditionsContainer.classList.remove("error");
        }

        if (firstAttemptStartingChat) {
            $(DOMElements.presurveyInfoContainer).slideDown({
                complete: function () {
                    DOMOperations.scrollElementToBottom(DOMElements.presurveyScroller);
                }
            });
        } else {
            $(DOMElements.presurveyInfoContainer).animate({opacity: 1}, {
                complete: function () {
                    DOMOperations.scrollElementToBottom(DOMElements.presurveyScroller);
                }
            });
        }

        firstAttemptStartingChat = false;

        /**setTimeout(function() {
	    	DOMOperations.scrollElementToBottom(DOMElements.presurveyScroller);
	    }, 1000);**/
    }
}

//DOMElements.startChatButton.onclick = tryToStartChat

DOMElements.presurveyForm.onsubmit = tryToStartChat;

DOMElements.sendButton.onclick = handleMessage

//DOMElements.minimizeButton.onclick = DOMOperations.toggleMinimized

//DOMElements.lcWindowMinimized.onclick = DOMOperations.toggleMinimized


DOMElements.input.onkeydown = event => {
    if (event.which !== 13) {
        return
    }
    event.preventDefault()
    handleMessage()
}

const loadHistory = chat => {
    return new Promise((resolve, reject) => {
        state.historyStatus = historyStates.LOADING
        state.history.next().then(
            result => {
                if (!result.value) {
                    return
                }

                const threads = result.value.threads || [];

                if (isDebug) console.log({threads});

                const events = threads
                    .map(thread => thread.events || [])
                    .reduce((acc, current) => acc.concat(current), [])

                if (isDebug) console.log({events});

                console.log({users: state.users});

                const messages = events
                    .filter(event => event.type === 'message')
                    .map(event => {
                        const author = state.users[event.authorId]
                        return DOMOperations.createMessage(
                            event.id,
                            event.text,
                            isAgent(author) ? 'agent' : 'customer',
                            author.avatar,
                        )
                    })

                if (isDebug) console.log({messages});

                const messageList = DOMOperations.getMessageList(chat);

                const welcomeMessages = [];
                if (messages.length) {
                    welcomeMessages.push(messages[0]);
                }
                if (messages.length > 1) {
                    welcomeMessages.push(messages[messages.length - 1]);
                }
                if (isDebug) console.log({welcomeMessages});
                DOMOperations.prependMessages(chat, welcomeMessages)

                const fromTheBottom = messageList.scrollHeight - (messageList.scrollTop + messageList.clientHeight)

                messageList.scrollTop = messageList.scrollHeight - messageList.clientHeight - fromTheBottom

                state.historyStatus = result.done ? historyStates.DONE : historyStates.INACTIVE
                resolve()
            },
            err => {
                state.historyStatus = historyStates.INACTIVE
                reject(err)
            },
        )
    })
}

const loadInitialHistory = () => {
    const chatId = state.chat

    state.history = sdk.getChatHistory({chatId})

    //console.log(state.history);

    if (isDebug) console.log(JSON.stringify(state.history));

    const loadLatestHistory = () => loadHistory(chatId).then(() => DOMOperations.scrollToBottom(chatId))

    return loadLatestHistory()
        .catch(() => loadLatestHistory())
        .catch(noop)
}

DOMOperations.delegate(
    '#lc',
    '.chat',
    'mousewheel',
    DOMOperations.throttle(300, function loadMore() {
        const chatId = this.dataset.id
        const chat = state.chats[chatId]

        if (this.scrollTop < 50 && chat.historyStatus === historyStates.INACTIVE) {
            loadHistory(chatId).catch(noop)
        }
    }),
)

window.addEventListener('beforeunload', sdk.disconnect);

start_widget();
$('.choice-field__wrapper').click((e) => {
    $(e.currentTarget).closest('.choice-field').find('input[type="checkbox"]').click()
});
